var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1364_750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9663 6.00242V22.6151C22.9663 23.0693 22.5981 23.4375 22.1435 23.4375H18.7568L11.9616 21.5722L5.16634 23.4375H1.77974C1.32511 23.4375 0.956909 23.0693 0.956909 22.6151V6.00242L11.9616 0.293518L22.9663 6.00242Z",
    fill: "url(#paint0_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6041 9.15908H9.31904C9.14121 9.15908 8.99707 9.01494 8.99707 8.83711C8.99707 8.65928 9.14121 8.51514 9.31904 8.51514H14.6041C14.7819 8.51514 14.9261 8.65928 14.9261 8.83711C14.9261 9.01494 14.7819 9.15908 14.6041 9.15908Z",
    fill: "url(#paint1_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6041 8.07095H9.31904C9.14121 8.07095 8.99707 7.92681 8.99707 7.74897C8.99707 7.57114 9.14121 7.427 9.31904 7.427H14.6041C14.7819 7.427 14.9261 7.57114 14.9261 7.74897C14.9261 7.92681 14.7819 8.07095 14.6041 8.07095Z",
    fill: "url(#paint2_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6041 6.98287H9.31904C9.14121 6.98287 8.99707 6.83873 8.99707 6.6609C8.99707 6.48307 9.14121 6.33893 9.31904 6.33893H14.6041C14.7819 6.33893 14.9261 6.48307 14.9261 6.6609C14.9261 6.83873 14.7819 6.98287 14.6041 6.98287Z",
    fill: "url(#paint3_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6041 5.8948H9.31904C9.14121 5.8948 8.99707 5.75066 8.99707 5.57283C8.99707 5.395 9.14121 5.25085 9.31904 5.25085H14.6041C14.7819 5.25085 14.9261 5.395 14.9261 5.57283C14.9261 5.75066 14.7819 5.8948 14.6041 5.8948Z",
    fill: "url(#paint4_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.956909 6.00231V14.1261H22.9662V6.00231L11.9616 0.293518L0.956909 6.00231Z",
    fill: "url(#paint5_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9662 6.00231V14.1261H0.956909V6.00231L11.9616 0.293518L22.9662 6.00231Z",
    fill: "url(#paint6_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9663 6.00242V22.6151C22.9663 23.0693 22.5981 23.4375 22.1434 23.4375H18.7568L11.9615 21.5722V0.293518L22.9663 6.00242Z",
    fill: "url(#paint7_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9663 16.8581V22.6151C22.9663 23.0693 22.5981 23.4375 22.1435 23.4375H18.7568L11.9616 21.5722L5.16634 23.4375H1.77974C1.32511 23.4375 0.956909 23.0693 0.956909 22.6151V16.8581H22.9663Z",
    fill: "url(#paint8_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7512 0.0513281L0.246621 6.01939C0.0950977 6.09803 0 6.25447 0 6.42516V7.97379C0 8.31656 0.36334 8.5374 0.667617 8.37955L11.7512 2.62986C11.8832 2.56137 12.0402 2.56137 12.1721 2.62986L23.2557 8.37955C23.56 8.5374 23.9233 8.31656 23.9233 7.97379V6.42516C23.9233 6.25447 23.8282 6.09797 23.6767 6.01939L12.1721 0.0513281C12.0401 -0.0171094 11.8831 -0.0171094 11.7512 0.0513281Z",
    fill: "url(#paint9_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7512 0.0513281L0.246621 6.01939C0.0950977 6.09803 0 6.25447 0 6.42516V7.97379C0 8.31656 0.36334 8.5374 0.667617 8.37955L11.7512 2.62986C11.8832 2.56137 12.0402 2.56137 12.1721 2.62986L23.2557 8.37955C23.56 8.5374 23.9233 8.31656 23.9233 7.97379V6.42516C23.9233 6.25447 23.8282 6.09797 23.6767 6.01939L12.1721 0.0513281C12.0401 -0.0171094 11.8831 -0.0171094 11.7512 0.0513281Z",
    fill: "url(#paint10_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7512 1.20166L0 7.29763V7.97381C0 8.31658 0.36334 8.53742 0.667617 8.37957L11.7512 2.62988C11.8831 2.56144 12.0402 2.56144 12.1721 2.62988L23.2557 8.37957C23.56 8.53742 23.9233 8.31658 23.9233 7.97381V7.29763L12.1721 1.20166C12.0401 1.13322 11.8831 1.13322 11.7512 1.20166Z",
    fill: "url(#paint11_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6767 6.01942L18.1399 3.14716V5.72575L23.2557 8.37964C23.56 8.53749 23.9233 8.31665 23.9233 7.97388V6.42524C23.9233 6.2545 23.8282 6.09805 23.6767 6.01942Z",
    fill: "url(#paint12_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2556 8.37961C23.5599 8.53746 23.9233 8.31662 23.9233 7.97385V6.42521C23.9233 6.25453 23.8282 6.09803 23.6766 6.01945L20.8238 4.53949H15.8531L23.2556 8.37961Z",
    fill: "url(#paint13_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.667617 8.37961L8.07018 4.53949H3.09949L0.246621 6.01939C0.0950977 6.09803 0 6.25447 0 6.42515V7.97379C0 8.31662 0.36334 8.53746 0.667617 8.37961Z",
    fill: "url(#paint14_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7569 12.0441V23.4375H5.16638V12.0441C5.16638 11.5665 5.55328 11.1801 6.03035 11.1801H17.8929C18.37 11.1801 18.7569 11.5665 18.7569 12.0441Z",
    fill: "url(#paint15_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5677 19.2963L14.724 17.4527V21.5271H16.5677V19.2963Z",
    fill: "url(#paint16_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.299 11.1801V23.4375H5.16638V12.0441C5.16638 11.5665 5.55328 11.1801 6.03035 11.1801H12.299Z",
    fill: "url(#paint17_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8929 11.1798H6.03071C5.55358 11.1798 5.16675 11.5666 5.16675 12.0438V16.7091H18.7568V12.0438C18.7569 11.5666 18.3701 11.1798 17.8929 11.1798Z",
    fill: "url(#paint18_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8902 17.843V24.0475C14.8902 24.2992 14.717 24.518 14.472 24.5757L9.12209 25.8378C9.04011 25.857 8.95498 25.857 8.873 25.8378L3.5231 24.5757C3.27812 24.518 3.10486 24.2992 3.10486 24.0475V17.843C3.10486 17.6916 3.16755 17.5525 3.2705 17.4528H14.7239V17.4522C14.8275 17.5519 14.8902 17.6913 14.8902 17.843Z",
    fill: "url(#paint19_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.724 17.4527H11.4121V25.2976L14.472 24.5757C14.717 24.5179 14.8902 24.2992 14.8902 24.0475V17.843C14.8902 17.6913 14.8275 17.5519 14.724 17.4522V17.4527Z",
    fill: "url(#paint20_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99757 17.4527V25.8521C8.95585 25.8521 8.91414 25.8474 8.873 25.8378L3.5231 24.5757C3.27812 24.5179 3.10486 24.2992 3.10486 24.0475V17.843C3.10486 17.6916 3.16755 17.5525 3.2705 17.4528L8.99757 17.4527Z",
    fill: "url(#paint21_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8901 17.8429V24.0473C14.8901 24.2992 14.7171 24.518 14.4722 24.5758L9.12208 25.8376C9.08124 25.8472 9.03963 25.8518 8.99768 25.8518V17.4527H14.7241C14.8277 17.5521 14.8901 17.6911 14.8901 17.8429Z",
    fill: "url(#paint22_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99757 22.0267V25.852C8.95585 25.852 8.91414 25.8474 8.873 25.8377L3.5231 24.5757C3.27812 24.5179 3.10486 24.2992 3.10486 24.0475V20.7087L8.39611 21.9567C8.59386 22.0034 8.79572 22.0267 8.99757 22.0267Z",
    fill: "url(#paint23_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99756 22.0267V25.852C9.03928 25.852 9.081 25.8474 9.12213 25.8377L14.472 24.5757C14.717 24.5179 14.8903 24.2992 14.8903 24.0475V20.7087L9.59902 21.9567C9.40121 22.0034 9.19941 22.0267 8.99756 22.0267Z",
    fill: "url(#paint24_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.724 17.4527L9.31114 18.7296C9.10495 18.7783 8.89026 18.7783 8.68401 18.7296L3.27112 17.4527C3.33967 17.3868 3.4254 17.3378 3.52284 17.3147L8.87303 16.0527C8.955 16.0334 9.04014 16.0334 9.12211 16.0527L11.1198 16.524V16.7646H12.1404L14.4723 17.3147C14.5698 17.3378 14.6555 17.3868 14.724 17.4527Z",
    fill: "url(#paint25_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1198 16.524V16.7646L5.73692 18.0346L3.27112 17.4527C3.33967 17.3868 3.4254 17.3378 3.52284 17.3147L8.87303 16.0527C8.955 16.0334 9.04014 16.0334 9.12211 16.0527L11.1198 16.524Z",
    fill: "url(#paint26_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1198 16.5237L5.33977 17.8874C5.27361 17.903 5.22691 17.962 5.22691 18.03L5.22656 19.8429C5.22656 19.8824 5.25375 19.9167 5.29219 19.9258L6.14273 20.1263C6.19617 20.1389 6.24744 20.0984 6.24744 20.0434V18.2605C6.24744 18.1985 6.2901 18.1447 6.35039 18.1304L12.1403 16.7645L11.1198 16.5237Z",
    fill: "url(#paint27_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97666 17.747L6.35027 18.1305C6.32637 18.1361 6.30533 18.1483 6.28846 18.1643L5.27197 17.9246C5.29037 17.9068 5.3134 17.8936 5.33965 17.8873L6.95555 17.506L7.97666 17.747Z",
    fill: "url(#paint28_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27197 17.9246L6.28816 18.1644C6.26279 18.1889 6.24732 18.2233 6.24732 18.2607V20.0434C6.24732 20.0985 6.19599 20.1391 6.14261 20.1262L5.29207 19.9258C5.25357 19.9168 5.22644 19.8824 5.22644 19.843L5.22673 18.0299C5.22673 17.9888 5.24396 17.9512 5.27197 17.9246Z",
    fill: "url(#paint29_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22656 18.97L5.22644 19.843C5.22644 19.8823 5.25357 19.9167 5.29207 19.9258L6.14261 20.1262C6.19599 20.139 6.24732 20.0985 6.24732 20.0434V18.97H5.22656Z",
    fill: "url(#paint30_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75012 23.7977L6.09521 24.3509C6.17291 24.3693 6.24732 24.3103 6.24732 24.2305V22.9426C6.24732 22.8852 6.20789 22.8354 6.15199 22.8222L3.80689 22.2691C3.7292 22.2507 3.65479 22.3097 3.65479 22.3895V23.6773C3.65479 23.7347 3.69428 23.7846 3.75012 23.7977Z",
    fill: "url(#paint31_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65479 22.7546V23.6773C3.65479 23.7347 3.69422 23.7845 3.75012 23.7977L6.09521 24.351C6.17291 24.3693 6.24732 24.3104 6.24732 24.2306V23.3662L3.65479 22.7546Z",
    fill: "url(#paint32_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1521 22.8222L4.96118 22.5413V24.0834L6.09526 24.351C6.17296 24.3693 6.24737 24.3104 6.24737 24.2306V22.9426C6.24737 22.8852 6.20794 22.8353 6.1521 22.8222Z",
    fill: "url(#paint33_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9251 21.9908V28.1953C18.9251 28.447 18.7519 28.6657 18.5069 28.7235L13.157 29.9856C13.075 30.0048 12.9899 30.0048 12.9079 29.9856L7.55801 28.7235C7.31303 28.6657 7.13977 28.447 7.13977 28.1953V21.9908C7.13977 21.8394 7.20247 21.7003 7.30542 21.6006H18.7589V21.6C18.8624 21.6997 18.9251 21.8391 18.9251 21.9908Z",
    fill: "url(#paint34_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7589 21.6006H15.447V29.4454L18.5069 28.7235C18.7519 28.6657 18.9251 28.447 18.9251 28.1953V21.9908C18.9251 21.8391 18.8625 21.6997 18.7589 21.6V21.6006Z",
    fill: "url(#paint35_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0325 21.6005V29.9999C12.9908 29.9999 12.949 29.9952 12.9079 29.9856L7.55801 28.7235C7.31303 28.6658 7.13977 28.447 7.13977 28.1953V21.9908C7.13977 21.8394 7.20247 21.7003 7.30542 21.6006H13.0325V21.6005Z",
    fill: "url(#paint36_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0325 26.1745V29.9998C12.9908 29.9998 12.949 29.9951 12.9079 29.9855L7.55801 28.7235C7.31303 28.6657 7.13977 28.447 7.13977 28.1952V24.8564L12.431 26.1045C12.6288 26.1512 12.8307 26.1745 13.0325 26.1745Z",
    fill: "url(#paint37_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0325 26.1745V29.9998C13.0742 29.9998 13.1159 29.9951 13.157 29.9855L18.5069 28.7235C18.7519 28.6657 18.9252 28.447 18.9252 28.1952V24.8564L13.6339 26.1045C13.4362 26.1512 13.2343 26.1745 13.0325 26.1745Z",
    fill: "url(#paint38_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7589 21.6005L13.346 22.8775C13.1399 22.9262 12.9252 22.9262 12.7189 22.8775L7.30603 21.6005C7.37458 21.5346 7.46031 21.4856 7.55775 21.4625L12.9079 20.2005C12.9899 20.1812 13.0751 20.1812 13.157 20.2005L15.1547 20.6718V20.9125H16.1753L18.5072 21.4625C18.6046 21.4856 18.6904 21.5346 18.7589 21.6005Z",
    fill: "url(#paint39_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1548 20.6718V20.9125L9.77195 22.1824L7.30615 21.6005C7.37471 21.5346 7.46043 21.4856 7.55787 21.4625L12.9081 20.2005C12.99 20.1812 13.0752 20.1812 13.1571 20.2005L15.1548 20.6718Z",
    fill: "url(#paint40_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1548 20.6715L9.37474 22.0352C9.30858 22.0508 9.26188 22.1099 9.26188 22.1778L9.26147 23.9907C9.26147 24.0302 9.28866 24.0646 9.3271 24.0736L10.1776 24.2741C10.2311 24.2867 10.2824 24.2462 10.2824 24.1912V22.4083C10.2824 22.3464 10.325 22.2925 10.3853 22.2783L16.1752 20.9124L15.1548 20.6715Z",
    fill: "url(#paint41_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0116 21.8947L10.3852 22.2783C10.3613 22.2839 10.3402 22.2961 10.3234 22.3121L9.30688 22.0723C9.32528 22.0545 9.34831 22.0414 9.37456 22.035L10.9905 21.6538L12.0116 21.8947Z",
    fill: "url(#paint42_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30688 22.0724L10.3231 22.3122C10.2977 22.3367 10.2822 22.3712 10.2822 22.4085V24.1912C10.2822 24.2463 10.2309 24.2869 10.1775 24.2741L9.32698 24.0737C9.28848 24.0646 9.26135 24.0302 9.26135 23.9908L9.26164 22.1777C9.2617 22.1366 9.27887 22.099 9.30688 22.0724Z",
    fill: "url(#paint43_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26147 23.1179L9.26135 23.9908C9.26135 24.0302 9.28848 24.0646 9.32698 24.0736L10.1775 24.274C10.2309 24.2869 10.2822 24.2463 10.2822 24.1912V23.1179H9.26147Z",
    fill: "url(#paint44_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78503 27.9455L10.1301 28.4988C10.2078 28.5171 10.2822 28.4582 10.2822 28.3784V27.0904C10.2822 27.033 10.2428 26.9832 10.1869 26.97L7.84181 26.4169C7.76411 26.3985 7.6897 26.4575 7.6897 26.5373V27.8251C7.68976 27.8825 7.72919 27.9323 7.78503 27.9455Z",
    fill: "url(#paint45_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6897 26.9024V27.8251C7.6897 27.8825 7.72913 27.9324 7.78503 27.9455L10.1301 28.4988C10.2078 28.5171 10.2822 28.4582 10.2822 28.3784V27.514L7.6897 26.9024Z",
    fill: "url(#paint46_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.187 26.97L8.99609 26.6891V28.2312L10.1302 28.4988C10.2079 28.5171 10.2823 28.4582 10.2823 28.3783V27.0904C10.2823 27.033 10.2429 26.9832 10.187 26.97Z",
    fill: "url(#paint47_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.352 30H16.57C16.2121 30 15.922 29.7099 15.922 29.352V13.7506C15.922 13.3928 16.2121 13.1027 16.57 13.1027H29.352C29.7099 13.1027 30 13.3928 30 13.7506V29.3519C30 29.7099 29.7099 30 29.352 30Z",
    fill: "url(#paint48_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.352 13.1027H23.041V30H29.352C29.7099 30 30 29.7099 30 29.352V13.7506C30 13.3928 29.7099 13.1027 29.352 13.1027Z",
    fill: "url(#paint49_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.352 13.1027H23.041V17.5255H30V13.7507C30 13.3928 29.7099 13.1027 29.352 13.1027Z",
    fill: "url(#paint50_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.352 30C29.7099 30 30 29.7099 30 29.352V15.5329L28.6226 14.1555H26.8566V30H29.352Z",
    fill: "url(#paint51_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.922 18.8864V29.352C15.922 29.7099 16.2121 29.9999 16.57 29.9999H29.352C29.7099 29.9999 30 29.7099 30 29.352V18.8864H15.922Z",
    fill: "url(#paint52_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3022 28.9766H17.6197C17.3619 28.9766 17.1528 28.7676 17.1528 28.5097V14.4873C17.1528 14.2294 17.3618 14.0204 17.6197 14.0204H28.3023C28.5601 14.0204 28.7692 14.2294 28.7692 14.4873V28.5097C28.7691 28.7675 28.5601 28.9766 28.3022 28.9766Z",
    fill: "url(#paint53_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3023 14.0204H24.8414V14.8149C24.8414 15.2754 24.4681 15.6487 24.0076 15.6487H21.1137L21.0547 15.7077L28.7692 23.4222V14.4873C28.7692 14.2295 28.5602 14.0204 28.3023 14.0204Z",
    fill: "url(#paint54_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3022 14.0204H25.3497V28.9766H28.3022C28.56 28.9766 28.7691 28.7676 28.7691 28.5097V14.4873C28.7691 14.2295 28.5601 14.0204 28.3022 14.0204Z",
    fill: "url(#paint55_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1528 25.0837V28.5097C17.1528 28.7675 17.3618 28.9766 17.6197 28.9766H28.3023C28.5601 28.9766 28.7692 28.7676 28.7692 28.5097V25.0837H17.1528Z",
    fill: "url(#paint56_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0807 13.9487H24.8414V15.6488H21.0807V13.9487Z",
    fill: "url(#paint57_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0807 13.9487H24.8414V15.6488H21.0807V13.9487Z",
    fill: "url(#paint58_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1558 15.9976H21.766C21.2119 15.9976 20.761 15.5468 20.761 14.9926V13.7H25.1608V14.9926C25.1609 15.5467 24.71 15.9976 24.1558 15.9976ZM21.2724 14.2113V14.9925C21.2724 15.2648 21.4939 15.4862 21.766 15.4862H24.1558C24.4281 15.4862 24.6495 15.2648 24.6495 14.9925V14.2113H21.2724Z",
    fill: "url(#paint59_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1558 15.9976H21.766C21.2119 15.9976 20.761 15.5468 20.761 14.9926V13.7H25.1608V14.9926C25.1609 15.5467 24.71 15.9976 24.1558 15.9976ZM21.2724 14.2113V14.9925C21.2724 15.2648 21.4939 15.4862 21.766 15.4862H24.1558C24.4281 15.4862 24.6495 15.2648 24.6495 14.9925V14.2113H21.2724Z",
    fill: "url(#paint60_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1558 15.9976H21.766C21.2119 15.9976 20.761 15.5468 20.761 14.9926V13.7H25.1608V14.9926C25.1609 15.5467 24.71 15.9976 24.1558 15.9976ZM21.2724 14.2113V14.9925C21.2724 15.2648 21.4939 15.4862 21.766 15.4862H24.1558C24.4281 15.4862 24.6495 15.2648 24.6495 14.9925V14.2113H21.2724Z",
    fill: "url(#paint61_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9222 14.2113H24.6495V14.9925C24.6495 15.2648 24.4281 15.4862 24.1559 15.4862H22.9221V15.9975H24.1559C24.71 15.9975 25.1609 15.5467 25.1609 14.9925V13.6999H22.9221L22.9222 14.2113Z",
    fill: "url(#paint62_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4801 13.5997C25.4801 13.9102 25.4197 14.1916 25.3215 14.3948C25.224 14.5981 25.0887 14.7242 24.9394 14.7242H20.9827C20.6841 14.7242 20.442 14.2207 20.442 13.5996C20.442 13.3337 20.4867 13.0858 20.5627 12.8911C20.6387 12.696 20.7461 12.554 20.8713 12.4991L21.0125 12.4372C21.059 12.4168 21.1097 12.4167 21.1563 12.437C22.3464 12.9589 23.5757 12.9589 24.7659 12.437C24.8125 12.4167 24.8631 12.4168 24.9097 12.4372L25.0509 12.4991C25.3011 12.6085 25.4801 13.0679 25.4801 13.5997Z",
    fill: "url(#paint63_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.381 13.7176C24.381 13.8927 24.347 14.0513 24.2916 14.1659C24.2367 14.2805 24.1604 14.3516 24.0762 14.3516H21.8458C21.6775 14.3516 21.541 14.0677 21.541 13.7177C21.541 13.5678 21.5662 13.4281 21.609 13.3183C21.6519 13.2083 21.7124 13.1283 21.7829 13.0974L21.8625 13.0624C21.8888 13.0509 21.9173 13.0509 21.9436 13.0623C22.6145 13.3565 23.3074 13.3565 23.9783 13.0623C24.0046 13.0509 24.0332 13.051 24.0594 13.0624L24.139 13.0974C24.2801 13.1589 24.381 13.4179 24.381 13.7176Z",
    fill: "url(#paint64_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.442 13.5997C20.442 14.2207 20.6841 14.7242 20.9827 14.7242H24.9394C25.0887 14.7242 25.224 14.5981 25.3215 14.3949C25.4197 14.1916 25.4801 13.9103 25.4801 13.5998C25.4801 13.5297 25.4769 13.461 25.4709 13.394H20.4513C20.4453 13.4609 20.442 13.5296 20.442 13.5997Z",
    fill: "url(#paint65_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0509 12.4992L24.9097 12.4373C24.8632 12.4168 24.8125 12.4168 24.7659 12.437C24.1041 12.7273 23.4302 12.8559 22.7576 12.8233V14.7242H24.9394C25.0887 14.7242 25.2241 14.5981 25.3216 14.3948C25.4198 14.1916 25.4801 13.9102 25.4801 13.5997C25.4801 13.0679 25.3011 12.6085 25.0509 12.4992Z",
    fill: "url(#paint66_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1845 17.8315H21.5928C21.4719 17.8315 21.374 17.7336 21.374 17.6128C21.374 17.492 21.4719 17.394 21.5928 17.394H27.1845C27.3054 17.394 27.4033 17.492 27.4033 17.6128C27.4033 17.7335 27.3053 17.8315 27.1845 17.8315Z",
    fill: "url(#paint67_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8798 18.4026H18.7375C18.6167 18.4026 18.5188 18.3047 18.5188 18.1839V17.0417C18.5188 16.9208 18.6167 16.8229 18.7375 16.8229H19.8798C20.0006 16.8229 20.0985 16.9208 20.0985 17.0417V18.1839C20.0985 18.3047 20.0006 18.4026 19.8798 18.4026Z",
    fill: "url(#paint68_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8798 18.4026H18.7375C18.6167 18.4026 18.5188 18.3047 18.5188 18.1839V17.0417C18.5188 16.9208 18.6167 16.8229 18.7375 16.8229H19.8798C20.0006 16.8229 20.0985 16.9208 20.0985 17.0417V18.1839C20.0985 18.3047 20.0006 18.4026 19.8798 18.4026Z",
    fill: "url(#paint69_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8798 18.4026H18.7375C18.6167 18.4026 18.5188 18.3047 18.5188 18.1839V17.0417C18.5188 16.9208 18.6167 16.8229 18.7375 16.8229H19.8798C20.0006 16.8229 20.0985 16.9208 20.0985 17.0417V18.1839C20.0985 18.3047 20.0006 18.4026 19.8798 18.4026Z",
    fill: "url(#paint70_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4748 18.1573C19.3732 18.1573 19.2776 18.1177 19.2057 18.0458L18.7844 17.6245C18.6845 17.5245 18.6845 17.3627 18.7844 17.2628C18.8842 17.163 19.0461 17.163 19.1459 17.2628L19.4748 17.5917L20.5306 16.5359C20.6305 16.4361 20.7924 16.4361 20.8922 16.5359C20.9921 16.6358 20.9921 16.7976 20.8922 16.8975L19.7439 18.0459C19.6721 18.1177 19.5765 18.1573 19.4748 18.1573Z",
    fill: "url(#paint71_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4748 18.1573C19.3732 18.1573 19.2776 18.1177 19.2057 18.0458L18.7844 17.6245C18.6845 17.5245 18.6845 17.3627 18.7844 17.2628C18.8842 17.163 19.0461 17.163 19.1459 17.2628L19.4748 17.5917L20.5306 16.5359C20.6305 16.4361 20.7924 16.4361 20.8922 16.5359C20.9921 16.6358 20.9921 16.7976 20.8922 16.8975L19.7439 18.0459C19.6721 18.1177 19.5765 18.1573 19.4748 18.1573Z",
    fill: "url(#paint72_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1845 20.0431H21.5928C21.4719 20.0431 21.374 19.9451 21.374 19.8243C21.374 19.7035 21.4719 19.6056 21.5928 19.6056H27.1845C27.3054 19.6056 27.4033 19.7035 27.4033 19.8243C27.4033 19.9451 27.3053 20.0431 27.1845 20.0431Z",
    fill: "url(#paint73_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8798 20.6142H18.7375C18.6167 20.6142 18.5188 20.5163 18.5188 20.3954V19.2532C18.5188 19.1324 18.6167 19.0345 18.7375 19.0345H19.8798C20.0006 19.0345 20.0985 19.1324 20.0985 19.2532V20.3954C20.0985 20.5163 20.0006 20.6142 19.8798 20.6142Z",
    fill: "url(#paint74_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8798 20.6142H18.7375C18.6167 20.6142 18.5188 20.5163 18.5188 20.3954V19.2532C18.5188 19.1324 18.6167 19.0345 18.7375 19.0345H19.8798C20.0006 19.0345 20.0985 19.1324 20.0985 19.2532V20.3954C20.0985 20.5163 20.0006 20.6142 19.8798 20.6142Z",
    fill: "url(#paint75_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8798 20.6142H18.7375C18.6167 20.6142 18.5188 20.5163 18.5188 20.3954V19.2532C18.5188 19.1324 18.6167 19.0345 18.7375 19.0345H19.8798C20.0006 19.0345 20.0985 19.1324 20.0985 19.2532V20.3954C20.0985 20.5163 20.0006 20.6142 19.8798 20.6142Z",
    fill: "url(#paint76_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4748 20.3689C19.3732 20.3689 19.2776 20.3292 19.2057 20.2573L18.7844 19.836C18.6845 19.7361 18.6845 19.5743 18.7844 19.4744C18.8842 19.3746 19.0461 19.3746 19.1459 19.4744L19.4748 19.8032L20.5306 18.7474C20.6305 18.6477 20.7924 18.6477 20.8922 18.7474C20.9921 18.8473 20.9921 19.0092 20.8922 19.1091L19.7439 20.2574C19.6721 20.3292 19.5765 20.3689 19.4748 20.3689Z",
    fill: "url(#paint77_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4748 20.3689C19.3732 20.3689 19.2776 20.3292 19.2057 20.2573L18.7844 19.836C18.6845 19.7361 18.6845 19.5743 18.7844 19.4744C18.8842 19.3746 19.0461 19.3746 19.1459 19.4744L19.4748 19.8032L20.5306 18.7474C20.6305 18.6477 20.7924 18.6477 20.8922 18.7474C20.9921 18.8473 20.9921 19.0092 20.8922 19.1091L19.7439 20.2574C19.6721 20.3292 19.5765 20.3689 19.4748 20.3689Z",
    fill: "url(#paint78_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1845 22.2546H21.5928C21.4719 22.2546 21.374 22.1567 21.374 22.0359C21.374 21.915 21.4719 21.8171 21.5928 21.8171H27.1845C27.3054 21.8171 27.4033 21.915 27.4033 22.0359C27.4033 22.1567 27.3053 22.2546 27.1845 22.2546Z",
    fill: "url(#paint79_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8798 22.8257H18.7375C18.6167 22.8257 18.5188 22.7278 18.5188 22.607V21.4648C18.5188 21.3439 18.6167 21.246 18.7375 21.246H19.8798C20.0006 21.246 20.0985 21.3439 20.0985 21.4648V22.607C20.0985 22.7278 20.0006 22.8257 19.8798 22.8257Z",
    fill: "url(#paint80_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8798 22.8257H18.7375C18.6167 22.8257 18.5188 22.7278 18.5188 22.607V21.4648C18.5188 21.3439 18.6167 21.246 18.7375 21.246H19.8798C20.0006 21.246 20.0985 21.3439 20.0985 21.4648V22.607C20.0985 22.7278 20.0006 22.8257 19.8798 22.8257Z",
    fill: "url(#paint81_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8798 22.8257H18.7375C18.6167 22.8257 18.5188 22.7278 18.5188 22.607V21.4648C18.5188 21.3439 18.6167 21.246 18.7375 21.246H19.8798C20.0006 21.246 20.0985 21.3439 20.0985 21.4648V22.607C20.0985 22.7278 20.0006 22.8257 19.8798 22.8257Z",
    fill: "url(#paint82_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4748 22.5804C19.3732 22.5804 19.2776 22.5408 19.2057 22.4689L18.7844 22.0475C18.6845 21.9476 18.6845 21.7858 18.7844 21.6859C18.8842 21.5861 19.0461 21.5861 19.1459 21.6859L19.4748 22.0148L20.5306 20.959C20.6305 20.8592 20.7924 20.8592 20.8922 20.959C20.9921 21.0589 20.9921 21.2207 20.8922 21.3206L19.7439 22.469C19.6721 22.5408 19.5765 22.5804 19.4748 22.5804Z",
    fill: "url(#paint83_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4748 22.5804C19.3732 22.5804 19.2776 22.5408 19.2057 22.4689L18.7844 22.0475C18.6845 21.9476 18.6845 21.7858 18.7844 21.6859C18.8842 21.5861 19.0461 21.5861 19.1459 21.6859L19.4748 22.0148L20.5306 20.959C20.6305 20.8592 20.7924 20.8592 20.8922 20.959C20.9921 21.0589 20.9921 21.2207 20.8922 21.3206L19.7439 22.469C19.6721 22.5408 19.5765 22.5804 19.4748 22.5804Z",
    fill: "url(#paint84_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1845 24.4684H21.5928C21.4719 24.4684 21.374 24.3705 21.374 24.2497C21.374 24.1289 21.4719 24.0309 21.5928 24.0309H27.1845C27.3054 24.0309 27.4033 24.1289 27.4033 24.2497C27.4033 24.3705 27.3053 24.4684 27.1845 24.4684Z",
    fill: "url(#paint85_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8798 25.0395H18.7375C18.6167 25.0395 18.5188 24.9416 18.5188 24.8208V23.6786C18.5188 23.5577 18.6167 23.4598 18.7375 23.4598H19.8798C20.0006 23.4598 20.0985 23.5577 20.0985 23.6786V24.8208C20.0985 24.9416 20.0006 25.0395 19.8798 25.0395Z",
    fill: "url(#paint86_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8798 25.0395H18.7375C18.6167 25.0395 18.5188 24.9416 18.5188 24.8208V23.6786C18.5188 23.5577 18.6167 23.4598 18.7375 23.4598H19.8798C20.0006 23.4598 20.0985 23.5577 20.0985 23.6786V24.8208C20.0985 24.9416 20.0006 25.0395 19.8798 25.0395Z",
    fill: "url(#paint87_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8798 25.0395H18.7375C18.6167 25.0395 18.5188 24.9416 18.5188 24.8208V23.6786C18.5188 23.5577 18.6167 23.4598 18.7375 23.4598H19.8798C20.0006 23.4598 20.0985 23.5577 20.0985 23.6786V24.8208C20.0985 24.9416 20.0006 25.0395 19.8798 25.0395Z",
    fill: "url(#paint88_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1845 26.6822H21.5928C21.4719 26.6822 21.374 26.5843 21.374 26.4635C21.374 26.3427 21.4719 26.2448 21.5928 26.2448H27.1845C27.3054 26.2448 27.4033 26.3427 27.4033 26.4635C27.4033 26.5843 27.3053 26.6822 27.1845 26.6822Z",
    fill: "url(#paint89_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8798 27.2533H18.7375C18.6167 27.2533 18.5188 27.1554 18.5188 27.0346V25.8924C18.5188 25.7716 18.6167 25.6736 18.7375 25.6736H19.8798C20.0006 25.6736 20.0985 25.7716 20.0985 25.8924V27.0346C20.0985 27.1554 20.0006 27.2533 19.8798 27.2533Z",
    fill: "url(#paint90_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8798 27.2533H18.7375C18.6167 27.2533 18.5188 27.1554 18.5188 27.0346V25.8924C18.5188 25.7716 18.6167 25.6736 18.7375 25.6736H19.8798C20.0006 25.6736 20.0985 25.7716 20.0985 25.8924V27.0346C20.0985 27.1554 20.0006 27.2533 19.8798 27.2533Z",
    fill: "url(#paint91_linear_1364_750)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8798 27.2533H18.7375C18.6167 27.2533 18.5188 27.1554 18.5188 27.0346V25.8924C18.5188 25.7716 18.6167 25.6736 18.7375 25.6736H19.8798C20.0006 25.6736 20.0985 25.7716 20.0985 25.8924V27.0346C20.0985 27.1554 20.0006 27.2533 19.8798 27.2533Z",
    fill: "url(#paint92_linear_1364_750)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1364_750",
    x1: 6.07736,
    y1: 9.18793,
    x2: 20.2819,
    y2: 21.9911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1364_750",
    x1: 11.9616,
    y1: 9.2257,
    x2: 11.9616,
    y2: 8.42355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1364_750",
    x1: 11.9616,
    y1: 8.13757,
    x2: 11.9616,
    y2: 7.33542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1364_750",
    x1: 11.9616,
    y1: 7.04949,
    x2: 11.9616,
    y2: 6.24729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1364_750",
    x1: 11.9616,
    y1: 5.96142,
    x2: 11.9616,
    y2: 5.15921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1364_750",
    x1: 10.1505,
    y1: 6.29709,
    x2: 8.95226,
    y2: 3.80481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2656,
    stopColor: "#034664",
    stopOpacity: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6092,
    stopColor: "#06365B",
    stopOpacity: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "#0B1B4C",
    stopOpacity: 0.994
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1B4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1364_750",
    x1: 13.7727,
    y1: 6.29709,
    x2: 14.971,
    y2: 3.80481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2656,
    stopColor: "#034664",
    stopOpacity: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6092,
    stopColor: "#06365B",
    stopOpacity: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "#0B1B4C",
    stopOpacity: 0.994
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1B4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1364_750",
    x1: 20.4929,
    y1: 11.8655,
    x2: 23.55,
    y2: 11.8655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2656,
    stopColor: "#034664",
    stopOpacity: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6092,
    stopColor: "#06365B",
    stopOpacity: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "#0B1B4C",
    stopOpacity: 0.994
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1B4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1364_750",
    x1: 11.9616,
    y1: 20.7727,
    x2: 11.9616,
    y2: 24.0145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2656,
    stopColor: "#034664",
    stopOpacity: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6092,
    stopColor: "#06365B",
    stopOpacity: 0.609
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "#0B1B4C",
    stopOpacity: 0.994
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1B4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1364_750",
    x1: 11.9616,
    y1: 0.513398,
    x2: 11.9616,
    y2: 8.46967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1364_750",
    x1: 11.7248,
    y1: 0.539121,
    x2: 11.9804,
    y2: 7.72852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1364_750",
    x1: 11.9616,
    y1: 5.65783,
    x2: 11.9616,
    y2: -0.151096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1364_750",
    x1: 22.7091,
    y1: 5.78938,
    x2: 24.0443,
    y2: 5.78938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1364_750",
    x1: 19.8882,
    y1: 5.97732,
    x2: 19.8882,
    y2: 8.69631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1364_750",
    x1: 4.03512,
    y1: 5.97732,
    x2: 4.03512,
    y2: 8.69631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1364_750",
    x1: 9.68548,
    y1: 13.0862,
    x2: 13.7492,
    y2: 21.2136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1364_750",
    x1: 18.2675,
    y1: 19.7852,
    x2: 14.7587,
    y2: 19.4928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3444,
    stopColor: "#403C40",
    stopOpacity: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6223,
    stopColor: "#363336",
    stopOpacity: 0.622
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8763,
    stopColor: "#252425",
    stopOpacity: 0.876
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1364_750",
    x1: 8.8347,
    y1: 17.3088,
    x2: 5.23658,
    y2: 17.3088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3444,
    stopColor: "#403C40",
    stopOpacity: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6223,
    stopColor: "#363336",
    stopOpacity: 0.622
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8763,
    stopColor: "#252425",
    stopOpacity: 0.876
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1364_750",
    x1: 11.9618,
    y1: 14.4441,
    x2: 11.9618,
    y2: 11.3789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3444,
    stopColor: "#403C40",
    stopOpacity: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6223,
    stopColor: "#363336",
    stopOpacity: 0.622
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8763,
    stopColor: "#252425",
    stopOpacity: 0.876
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1364_750",
    x1: 3.84537,
    y1: 16.8166,
    x2: 14.1169,
    y2: 25.0505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1364_750",
    x1: 13.0547,
    y1: 21.3749,
    x2: 15.0525,
    y2: 21.3749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8794,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1364_750",
    x1: 5.60699,
    y1: 20.2965,
    x2: 9.81753,
    y2: 25.5051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8794,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1364_750",
    x1: 11.1876,
    y1: 18.6282,
    x2: 11.8377,
    y2: 21.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8794,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1364_750",
    x1: 5.92316,
    y1: 23.9419,
    x2: 5.67367,
    y2: 25.2311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8794,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1364_750",
    x1: 12.072,
    y1: 23.9419,
    x2: 12.3215,
    y2: 25.2311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8794,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1364_750",
    x1: 8.9584,
    y1: 16.9298,
    x2: 9.11432,
    y2: 19.0091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1364_750",
    x1: 7.20715,
    y1: 17.0373,
    x2: 7.32147,
    y2: 17.5155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8794,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1364_750",
    x1: 7.96465,
    y1: 16.5614,
    x2: 8.77559,
    y2: 18.5366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1364_750",
    x1: 6.62432,
    y1: 17.764,
    x2: 6.62432,
    y2: 18.2192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1364_750",
    x1: 5.9956,
    y1: 19.0266,
    x2: 6.31025,
    y2: 19.0266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1364_750",
    x1: 5.70334,
    y1: 19.7006,
    x2: 5.64099,
    y2: 20.0541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1364_750",
    x1: 4.20592,
    y1: 22.0266,
    x2: 5.65289,
    y2: 24.5186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1364_750",
    x1: 4.93617,
    y1: 23.5648,
    x2: 4.82561,
    y2: 24.0471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1364_750",
    x1: 5.8756,
    y1: 23.4478,
    x2: 6.25224,
    y2: 23.4478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1364_750",
    x1: 7.88034,
    y1: 20.9645,
    x2: 18.1519,
    y2: 29.1984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1364_750",
    x1: 17.0896,
    y1: 25.5227,
    x2: 19.0875,
    y2: 25.5227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8794,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1364_750",
    x1: 9.64196,
    y1: 24.4443,
    x2: 13.8524,
    y2: 29.6529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8794,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1364_750",
    x1: 9.95813,
    y1: 28.0897,
    x2: 9.70858,
    y2: 29.3788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8794,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1364_750",
    x1: 16.1069,
    y1: 28.0897,
    x2: 16.3564,
    y2: 29.3788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8794,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1364_750",
    x1: 12.9933,
    y1: 21.0776,
    x2: 13.1492,
    y2: 23.1568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1364_750",
    x1: 11.2421,
    y1: 21.1851,
    x2: 11.3565,
    y2: 21.6633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#BE5539",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#AE4E35",
    stopOpacity: 0.539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8794,
    stopColor: "#934330",
    stopOpacity: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1364_750",
    x1: 11.9996,
    y1: 20.7091,
    x2: 12.8105,
    y2: 22.6844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1364_750",
    x1: 10.6592,
    y1: 21.9119,
    x2: 10.6592,
    y2: 22.3671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1364_750",
    x1: 10.0305,
    y1: 23.1744,
    x2: 10.3452,
    y2: 23.1744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1364_750",
    x1: 9.73831,
    y1: 23.8485,
    x2: 9.6759,
    y2: 24.2019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1364_750",
    x1: 8.24083,
    y1: 26.1744,
    x2: 9.6878,
    y2: 28.6665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1364_750",
    x1: 8.97103,
    y1: 27.7126,
    x2: 8.86052,
    y2: 28.1949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1364_750",
    x1: 9.91051,
    y1: 27.5956,
    x2: 10.2871,
    y2: 27.5956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1364_750",
    x1: 13.7135,
    y1: 14.7279,
    x2: 33.7391,
    y2: 29.5041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01D0FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1364_750",
    x1: 28.6307,
    y1: 21.5514,
    x2: 29.9511,
    y2: 21.5514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08A9F1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A9F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1364_750",
    x1: 26.6173,
    y1: 15.3763,
    x2: 24.8675,
    y2: 15.1008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08A9F1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A9F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1364_750",
    x1: 28.1041,
    y1: 22.3216,
    x2: 24.5073,
    y2: 19.9156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08A9F1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A9F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1364_750",
    x1: 22.961,
    y1: 28.6862,
    x2: 22.961,
    y2: 29.9865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08A9F1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A9F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1364_750",
    x1: 19.3831,
    y1: 17.9206,
    x2: 29.287,
    y2: 27.8245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1364_750",
    x1: 26.0673,
    y1: 17.0902,
    x2: 24.3456,
    y2: 14.0295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1364_750",
    x1: 27.6585,
    y1: 21.4985,
    x2: 28.7564,
    y2: 21.4985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1364_750",
    x1: 22.9609,
    y1: 27.6112,
    x2: 22.9609,
    y2: 28.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1364_750",
    x1: 22.961,
    y1: 15.4543,
    x2: 22.961,
    y2: 14.6732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1364_750",
    x1: 22.1445,
    y1: 14.7987,
    x2: 21.2695,
    y2: 14.7987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1364_750",
    x1: 22.9609,
    y1: 15.5434,
    x2: 22.9609,
    y2: 15.9809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1364_750",
    x1: 22.9609,
    y1: 15.5921,
    x2: 22.9609,
    y2: 15.9323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3444,
    stopColor: "#403C40",
    stopOpacity: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6223,
    stopColor: "#363336",
    stopOpacity: 0.622
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8763,
    stopColor: "#252425",
    stopOpacity: 0.876
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1364_750",
    x1: 22.9609,
    y1: 15.1951,
    x2: 22.9609,
    y2: 14.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3444,
    stopColor: "#403C40",
    stopOpacity: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6223,
    stopColor: "#363336",
    stopOpacity: 0.622
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8763,
    stopColor: "#252425",
    stopOpacity: 0.876
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1364_750",
    x1: 24.4708,
    y1: 15.0216,
    x2: 25.0541,
    y2: 15.2566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3444,
    stopColor: "#403C40",
    stopOpacity: 0.344
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6223,
    stopColor: "#363336",
    stopOpacity: 0.622
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8763,
    stopColor: "#252425",
    stopOpacity: 0.876
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1364_750",
    x1: 22.9611,
    y1: 12.9889,
    x2: 22.9611,
    y2: 14.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1364_750",
    x1: 22.961,
    y1: 14.4309,
    x2: 22.961,
    y2: 12.7744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1364_750",
    x1: 22.9611,
    y1: 14.2203,
    x2: 22.9611,
    y2: 14.7474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1364_750",
    x1: 24.4201,
    y1: 13.6456,
    x2: 25.5218,
    y2: 13.7753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1364_750",
    x1: 24.3501,
    y1: 11.9339,
    x2: 24.3988,
    y2: 19.1033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1364_750",
    x1: 17.8505,
    y1: 16.1546,
    x2: 20.3841,
    y2: 18.6882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1364_750",
    x1: 19.3086,
    y1: 17.6249,
    x2: 19.3086,
    y2: 16.7486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1364_750",
    x1: 19.8069,
    y1: 17.6128,
    x2: 18.3244,
    y2: 17.6128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1364_750",
    x1: 19.7839,
    y1: 16.797,
    x2: 20.0078,
    y2: 17.9629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBEC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1974,
    stopColor: "#B5E665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4799,
    stopColor: "#A5D552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8118,
    stopColor: "#8ABB33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A91F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1364_750",
    x1: 20.0592,
    y1: 17.3011,
    x2: 20.2758,
    y2: 17.5177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334C0F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3197,
    stopColor: "#344C12",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5654,
    stopColor: "#374A1C",
    stopOpacity: 0.565
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7856,
    stopColor: "#3C482C",
    stopOpacity: 0.786
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    stopColor: "#444443",
    stopOpacity: 0.991
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1364_750",
    x1: 24.3501,
    y1: 14.1454,
    x2: 24.3988,
    y2: 21.3148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1364_750",
    x1: 17.8505,
    y1: 18.3662,
    x2: 20.3841,
    y2: 20.8998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1364_750",
    x1: 19.3086,
    y1: 19.8365,
    x2: 19.3086,
    y2: 18.9602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1364_750",
    x1: 19.8069,
    y1: 19.8243,
    x2: 18.3244,
    y2: 19.8243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1364_750",
    x1: 19.7839,
    y1: 19.0085,
    x2: 20.0078,
    y2: 20.1744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBEC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1974,
    stopColor: "#B5E665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4799,
    stopColor: "#A5D552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8118,
    stopColor: "#8ABB33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A91F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1364_750",
    x1: 20.0592,
    y1: 19.5127,
    x2: 20.2758,
    y2: 19.7292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334C0F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3197,
    stopColor: "#344C12",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5654,
    stopColor: "#374A1C",
    stopOpacity: 0.565
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7856,
    stopColor: "#3C482C",
    stopOpacity: 0.786
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    stopColor: "#444443",
    stopOpacity: 0.991
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1364_750",
    x1: 24.3501,
    y1: 16.357,
    x2: 24.3988,
    y2: 23.5264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1364_750",
    x1: 17.8505,
    y1: 20.5777,
    x2: 20.3841,
    y2: 23.1113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1364_750",
    x1: 19.3086,
    y1: 22.048,
    x2: 19.3086,
    y2: 21.1718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1364_750",
    x1: 19.8069,
    y1: 22.0359,
    x2: 18.3244,
    y2: 22.0359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1364_750",
    x1: 19.7839,
    y1: 21.2201,
    x2: 20.0078,
    y2: 22.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBEC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1974,
    stopColor: "#B5E665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4799,
    stopColor: "#A5D552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8118,
    stopColor: "#8ABB33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78A91F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1364_750",
    x1: 20.0592,
    y1: 21.7242,
    x2: 20.2758,
    y2: 21.9408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334C0F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3197,
    stopColor: "#344C12",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5654,
    stopColor: "#374A1C",
    stopOpacity: 0.565
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7856,
    stopColor: "#3C482C",
    stopOpacity: 0.786
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    stopColor: "#444443",
    stopOpacity: 0.991
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1364_750",
    x1: 24.3501,
    y1: 18.5708,
    x2: 24.3988,
    y2: 25.7402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1364_750",
    x1: 17.8505,
    y1: 22.7915,
    x2: 20.3841,
    y2: 25.3252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1364_750",
    x1: 19.3086,
    y1: 24.2619,
    x2: 19.3086,
    y2: 23.3856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1364_750",
    x1: 19.8069,
    y1: 24.2497,
    x2: 18.3244,
    y2: 24.2497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1364_750",
    x1: 24.3501,
    y1: 20.7846,
    x2: 24.3988,
    y2: 27.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1364_750",
    x1: 17.8505,
    y1: 25.0053,
    x2: 20.3841,
    y2: 27.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1364_750",
    x1: 19.3086,
    y1: 26.4757,
    x2: 19.3086,
    y2: 25.5994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1364_750",
    x1: 19.8069,
    y1: 26.4635,
    x2: 18.3244,
    y2: 26.4635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1364_750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.6601783042a26889b14f707da88345c9.svg";
export { ForwardRef as ReactComponent };